import gql from 'graphql-tag'

const statsAgentiLineChartAndamentoAnnuale = gql`
  query statsAgentiLineChartAndamentoAnnuale(
    $tipoAndamento: TipoAndamentoAgenti, 
    $anno: Int!
  ) {
    statsAgentiLineChartAndamentoAnnuale(
      tipoAndamento: $tipoAndamento, 
      anno: $anno
    ) {
      nome
      colore
      valori 
    }
  }
`

export default statsAgentiLineChartAndamentoAnnuale


// WEBPACK FOOTER //
// ./src/graphql/queries/statsAgentiLineChartAndamentoAnnuale.js